import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { ContentWithVarsShape } from "../utils/types";

export default function StepHeader({
  title,
  description,
  htmlContent,
  imageSrc,
  variables: allVariables,
  emptyVariableFormatter,
}) {
  const formattedValues = useMemo(() => {
    function formatText({ content, variables: contentVariables }) {
      let formatedContent = content || "";

      contentVariables.forEach((variableId) => {
        const variableIds = variableId.split("-");
        const currentVariable = allVariables[variableIds[0]][variableIds[1]];
        const value = sessionStorage.getItem(`CUSTOM_VARIABLE_${currentVariable.name}`);

        /**
         * if value replace the variable name by the variable value,
         * else if emptyVariableFormatter use the custom formatter,
         * else return the content without replace variable.
         */

        if (value) {
          formatedContent = formatedContent.replace(`{{${currentVariable.name}}}`, value);
        } else if (emptyVariableFormatter) {
          formatedContent = emptyVariableFormatter(formatedContent, currentVariable);
        }
      });

      return formatedContent;
    }

    const formattedTitle = title.variables ? formatText(title) : title;
    const formattedDescription = description.variables
      ? formatText(description)
      : description;

    return { formattedTitle, formattedDescription };
  }, [title, description, allVariables, emptyVariableFormatter]);

  return (
    <div className="step-header">
      {imageSrc && <img className="step-header--img" src={imageSrc} alt="" />}

      {formattedValues.formattedTitle && <h1>{formattedValues.formattedTitle}</h1>}

      {formattedValues.formattedDescription && (
        <p>{formattedValues.formattedDescription}</p>
      )}

      {htmlContent && (
        <div
          style={{ width: "100%" }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      )}
    </div>
  );
}

StepHeader.propTypes = {
  title: ContentWithVarsShape,
  description: ContentWithVarsShape,
  htmlContent: PropTypes.string,
  imageSrc: PropTypes.string,
  variables: PropTypes.object.isRequired,
  emptyVariableFormatter: PropTypes.func,
};
